import React, { useContext } from 'react';
import Product from './product/Product';
import Selectable from '../common/Selectable';
import { ProductType } from '../common/CommonTypes';
import { VehicleContext } from '../../context/VehicleContext';

export type PoliciesProps = {
    vehicleIndex: number;
    selectedPolicyReference: string;
    policies: ProductType[];
    onPolicySelected: (productReference: string) => void;
};

const Policies = ({
    vehicleIndex,
    selectedPolicyReference,
    policies,
    onPolicySelected
}: PoliciesProps): JSX.Element => {
    const { setSelectedVehicle } = useContext(VehicleContext);

    const onPolicyClicked = (selected: boolean, policyReference: string) => {
        if (selected) {
            onPolicySelected(policyReference);
            setSelectedVehicle(vehicleIndex);
        } else {
            onPolicySelected('');
        }
    };

    return (
        <div className='card-body'>
            {policies.map((policy, index) => (
                <Selectable
                    id={`selectable-product-${index.toString()}`}
                    onClicked={(selected) =>
                        onPolicyClicked(selected, policy.reference)
                    }
                    selected={policy.reference === selectedPolicyReference}
                    hasSelectableButton={true}
                    style={{
                        border: '1px solid #ced4da',
                        marginTop: '10px'
                    }}
                    key={`product-selectable-${vehicleIndex.toString()}-${index.toString()}`}>
                    <Product
                        id={`product-${vehicleIndex.toString()}-${index.toString()}`}
                        product={policy}
                    />
                </Selectable>
            ))}
        </div>
    );
};

export default Policies;
